import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface BreadcrumbProps {
  items?: { label: string; path?: string }[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  const generateItems = () => {
    if (items) return items;

    const paths = location.pathname.split('/').filter(Boolean);
    const result: { label: string; path?: string }[] = [{ label: '首页', path: '/' }];

    if (paths[0] === 'category' && paths[1]) {
      const cat = categories.find((c) => c.slug === paths[1]);
      result.push({ label: '分类', path: '/category/meiri-chigua' });
      result.push({ label: cat?.name || paths[1] });
    } else if (paths[0] === 'article' && paths[1]) {
      result.push({ label: '文章详情' });
    } else if (paths[0] === 'about') {
      result.push({ label: '关于我们' });
    }

    return result;
  };

  const breadcrumbItems = generateItems();

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbItems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.path ? `http://lalaxjk.cn/${item.path}` : undefined,
    })),
  };

  return (
    <nav aria-label="面包屑导航" className="py-3">
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
        {breadcrumbItems.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && <i className="ri-arrow-right-s-line text-foreground-400" />}
            {item.path && index < breadcrumbItems.length - 1 ? (
              <Link
                to={item.path}
                className="hover:text-primary-500 transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}